<template>
<el-popover v-model="isDeviceTypeTreeShowed" placement="bottom-start" :width="popoverWidth" trigger="focus"
            transition="none" :disabled="disabled" @show="deviceTypeTreeShowed" @hide="deviceTypeTreeHidden">
  <tree :style="{height: popoverHeight+'px'}" ref="deviceTypeTree" :props="deviceTypeProps" :data="deviceTypeTreeData"
        :default-expanded-keys="deviceTypeExpandKeys" node-key="id" @treenode-click="deviceTypeSelected(arguments[0])"
        v-loading="(mode===0&&isDeviceTypeLoading)||(mode===1&&isTreeDataLoading)"></tree>
  <el-input slot="reference" :placeholder="placeholder" :value="value" :disabled="disabled"
            @input="$emit('input', arguments[0])" clearable readonly></el-input>
</el-popover>
</template>
<script>
import Tree from '@/components/tree/treeNew'

export default {
  name: 'deviceTypeTreeInput',
  components: {
    Tree
  },
  props: {
    value: String,
    disabled: Boolean,
    popoverWidth: {
      type: Number,
      default: 200
    },
    popoverHeight: {
      type: Number,
      default: 400
    },
    placeholder: {
      type: String,
      default: '请选择设备类别'
    },
    mode: { // 0：控件自己取数据, 1：控件父级传入数据
      type: Number,
      default: 0
    },
    showedMaxLevel: {
      type: Number,
      default: 3
    },
    // 以下是当mode等于1时，父级出入的tree数据
    isTreeDataLoading: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default () {
        return []
      }
    },
    treeProps: {
      type: Object,
      default () {
        return {
          children: 'children',
          label: 'name'
          // label: 'modelName'
        }
      }
    },
    treeDefaultExpandedKeys: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isDeviceTypeTreeShowed: false,
      isDeviceTypeLoading: false,
      deviceTypeTreeData: [],
      deviceTypeExpandKeys: [],
      deviceTypeProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  methods: {
    deviceTypeTreeShowed () {
      this.$emit('deviceTypeTreeShowed')
    },
    deviceTypeTreeHidden () {
      this.$emit('deviceTypeTreeHidden')
    },
    deviceTypeSelected (val) {
      this.$emit('deviceTypeSelected', val)
    },
    showDeviceTypeTree () {
      this.isDeviceTypeTreeShowed = true
    },
    hideDeviceTypeTree () {
      this.isDeviceTypeTreeShowed = false
    },
    treeFilter (val) {
      this.$refs.deviceTypeTree && this.$refs.deviceTypeTree.filter(val)
    },
    setTreeCurrentKey (val) {
      this.$refs.deviceTypeTree && this.$refs.deviceTypeTree.setCurrentKey(val)
    },
    async getDeviceCategory () {
      this.isDeviceTypeLoading = true
      try {
        const responseData = await this.$https.axios({ method: 'get', url: 'console/equipmentListQuery' })
        // let deviceTypeTrees = JSON.stringify(responseData.data).replace(/deviceTypes/g, 'children').replace(/deviceModelList/g, 'children')
        // this.deviceTypeTreeData = JSON.parse(deviceTypeTrees)
        this.deviceTypeTreeData = []
        let deviceTypeTreeDatas = []
        for (const deviceCategoryData of responseData.data) {
          deviceCategoryData.children = deviceCategoryData.deviceTypes
          for (const devices of deviceCategoryData.children) {
            devices.children = devices.deviceModelList
            for (const devicess of devices.children) {
              devicess.name = devicess.modelName
            }
          }
          deviceTypeTreeDatas.push(deviceCategoryData)
        }
        this.deviceTypeTreeData.push({name: '全部', children: deviceTypeTreeDatas})
      } catch (e) {
        console.log(e)
      }
      this.isDeviceTypeLoading = false
    }
  },
  watch: {
    treeData (val) {
      this.deviceTypeTreeData = val
    }
  },
  mounted () {
    if (this.mode === 1) {
      this.deviceTypeProps = this.treeProps
      this.deviceTypeTreeData = this.treeData
      this.deviceTypeExpandKeys = this.treeDefaultExpandedKeys
    } else {
      this.getDeviceCategory()
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/deviceTypeTreeHome.vue